<template>
  <div class="progress-bar">
    <div
      :class="[
        'has-s-body-size',
        'data',
        { right: progress < 0.4 }
      ]"
    >
      <span>
        {{ stars }}<template v-if="nextStars">/{{nextStars}}</template>
      </span>
      <StarIcon
        :class="[
          'star',
          'animate__animated',
          'animate__bounceIn'
        ]"
        filled
      />
    </div>
    <div class="progress" :style="{ width: `${progress * 100}%` }" />
    <div class="total" />
  </div>
</template>

<script>
import {ref, onUpdated} from '@vue/composition-api'

import StarIcon from '@/components/StarIcon'

export default {
  props: {
    stars: {type: Number, required: true},
    prevStars: {type: Number, required: true},
    nextStars: {type: Number, required: false},
  },
  components: {
    StarIcon,
  },
  setup (props) {
    const progress = ref(getProgress(props.stars, props.prevStars, props.nextStars))

    onUpdated(() => {
      progress.value = getProgress(props.stars, props.prevStars, props.nextStars)
    })

    return {
      progress,
    }
  },
}

function getProgress (stars, prevStars, nextStars) {
  if (!nextStars) return 1
  return (stars - prevStars) / (nextStars - prevStars)
}
</script>

<style scoped lang="scss">
.progress-bar {
  position: relative;
  height: 25px;
  z-index: 10;
  color: variables.$color-purple;

  .progress {
    position: absolute;
    height: 100%;
    border-radius: 40px;
    background: linear-gradient(90deg, #FE9EB9 0%, #FFF39E 100%);
    z-index: 2;
  }

  .total {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 40px;
    background: variables.$color-purple;
    box-shadow: 4px 4px 4px #00000014;
    border-radius: 40px;
    opacity: 0.24;
  }

  .data {
    position: absolute;
    height: 100%;
    z-index: 3;
    padding: 0 16px;
    line-height: 25px;

    &.right {
      right: 0;
    }

    .star {
      margin-left: 0.3em;
      width: 0.8em;
      height: 0.8em;
    }
  }
}

</style>
